import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { HttpResponseSuccess } from '@/services/service';
import { useDispatch } from 'react-redux';
import { userGetUserRequest } from '@/modules/user/userActions';
import {
	updateOnboardingStatus,
	OnboardingStatusPayload,
	OnboardingStatusResponse,
	ONBOARDING_STATUS_QUERY_KEY
} from '@/services/onboardingStatusService';

export type { OnboardingStatusResponse, OnboardingStatusPayload };
export { ONBOARDING_STATUS_QUERY_KEY };

export const useUpdateOnboardingStatus = (): UseMutationResult<
	HttpResponseSuccess<OnboardingStatusResponse>,
	Error,
	OnboardingStatusPayload
> => {
	const dispatch = useDispatch();

	return useMutation({
		mutationFn: updateOnboardingStatus,
		onSuccess: () => {
			// Refresh the user data in Redux after successful update
			dispatch(userGetUserRequest());
		},
		onError: error => {
			throw new Error('Error updating onboarding status:', error);
		}
	});
};
